import { NgModule } from '@angular/core';
import { UnlockDeviceModalModule } from './unlock-device-modal/unlock-device-modal.module';

@NgModule({
	imports: [UnlockDeviceModalModule],
	exports: [UnlockDeviceModalModule],
	declarations: [],
	providers: [],
})
export class SecurityModule { }